import React, {useMemo} from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { AdminsFilter } from "./admins-filter/AdminsFilter";
import { AdminsTable } from "./admins-table/AdminsTable";
import { AdminsGrouping } from "./admins-grouping/AdminsGrouping";
import { useAdminsUIContext } from "./AdminsUIContext";

export function AdminsCard() {
  const adminsUIContext = useAdminsUIContext();
  const adminsUIProps = useMemo(() => {
    return {
      ids: adminsUIContext.ids,
      queryParams: adminsUIContext.queryParams,
      setQueryParams: adminsUIContext.setQueryParams,
      newAdminButtonClick: adminsUIContext.newAdminButtonClick,
      openDeleteAdminsDialog: adminsUIContext.openDeleteAdminsDialog,
      openEditAdminPage: adminsUIContext.openEditAdminPage,
      openUpdateAdminsStatusDialog:
        adminsUIContext.openUpdateAdminsStatusDialog,
      openFetchAdminsDialog: adminsUIContext.openFetchAdminsDialog,
    };
  }, [adminsUIContext]);
  return (
    <Card>
      <CardHeader title="Admin List">
        <CardHeaderToolbar>
         <button
            type="button"
            className="btn btn-primary"
            onClick={adminsUIProps.newAdminButtonClick}
          >
            New Admin
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <AdminsFilter />
        {adminsUIProps.ids.length > 0 && (
          <>
            <AdminsGrouping />
          </>
        )}
        <AdminsTable />
      </CardBody>
    </Card>
  );
}
